import { render, staticRenderFns } from "./ButtonComp.vue?vue&type=template&id=a9a89322&scoped=true&"
import script from "./ButtonComp.vue?vue&type=script&lang=js&"
export * from "./ButtonComp.vue?vue&type=script&lang=js&"
import style0 from "./ButtonComp.vue?vue&type=style&index=0&id=a9a89322&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a89322",
  null
  
)

export default component.exports